// Versão publicada: package.json + commit + data do build (injetados pelo Vite em build time).
export const APP_VERSION = `v${__APP_VERSION__} · ${__APP_COMMIT__} · ${__APP_BUILD_DATE__}`;
